// Local, ui-only stage overrides by dealId.
// TODO: drop once backend mutations + invalidation are reliable in dev — this
// slice exists so kanban and deal-detail mirror each other when running on mocks.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { DealStage } from '@/types'

interface DealStageOverridesState {
	byId: Record<string, DealStage>
	hidden: string[]
}

interface SliceRoot { dealStageOverrides: DealStageOverridesState }

const initialState: DealStageOverridesState = {
	byId: {},
	hidden: [],
}

const slice = createSlice({
	name: 'dealStageOverrides',
	initialState,
	reducers: {
		setDealStage(state, action: PayloadAction<{ id: string; stage: DealStage }>) {
			state.byId[action.payload.id] = action.payload.stage
		},
		hideDeal(state, action: PayloadAction<string>) {
			if (!state.hidden.includes(action.payload)) state.hidden.push(action.payload)
		},
		clearOverride(state, action: PayloadAction<string>) {
			delete state.byId[action.payload]
		},
	},
})

export const { setDealStage, hideDeal, clearOverride } = slice.actions
export const dealStageOverridesReducer = slice.reducer

export const selectDealStageOverrides = (s: SliceRoot) => s.dealStageOverrides.byId
export const selectHiddenDealIds      = (s: SliceRoot) => s.dealStageOverrides.hidden
